module.exports = __webpack_public_path__ + "static-m/img/2.d9f5b75c.png";